
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">Reporting Set</div>
    <div class="custom-setting-section-context">{{ selectedReportingSet?.ReportingSetName }} ({{ selectedDateField }})</div>
    <div class="custom-setting-section-body">
        <div class="mb-2 font-size-12">Reporting Set</div>
        <select class="form-control mb-3" [(ngModel)]="selectedReportingSet" (change)="onReportingSetSelected()">
            <option *ngFor="let rs of definitions;" [ngValue]="rs">{{ rs.ReportingSetName }} ({{ rs.ReportingSetGroup }})</option>
        </select>
        <div class="mb-2 font-size-12">Date Field</div>
        <select class="form-control mb-3" type="text" [(ngModel)]="selectedDateField" [disabled]="selectedReportingSet === null">
            <option *ngFor="let df of dates" >{{ df }}</option>
        </select>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
<div cvModuleLegacyCustomSettingSection [moduleManager]="moduleManager">
    <div class="gridItemSettingsPanelCustomSettingsBottomItem">
        <div class="settingsSectionTitle mb-1">Select Reporting Set</div>
        <select class="form-control w-50 mb-2" [(ngModel)]="selectedReportingSet" (change)="onReportingSetSelected()">
            <option *ngFor="let rs of definitions" [ngValue]="rs">{{ rs.ReportingSetName }} ({{ rs.ReportingSetGroup }})</option>
        </select>
        <div class="settingsSectionTitle mb-1">Select Date Field</div>
        <select class="form-control w-50 mb-2" type="text" [(ngModel)]="selectedDateField" [disabled]="selectedReportingSet === null">
            <option *ngFor="let df of dates">{{ df }}</option>
        </select>
    </div>
</div>
</ng-container>
